export class ClaimsHelper {
    public static MapClaimsToUser(claims: any) {
        // Disguise the Justis domain from EZ Proxy
        const justisPrefix = "http://" + ["justis", "com"].join(".");
        return {
           userName             :   claims["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"],
           UserId               :   claims[`${justisPrefix}/claims/userid`],
           Id                   :   claims[`${justisPrefix}/claims/sessionsiteid`],
           PersonalId           :   claims[`${justisPrefix}/claims/personalid`],
           IsAuthenticated      :   claims.IsAuthenticated,
           OrganisationName     :   claims[`${justisPrefix}/claims/organisation`],
           IsIpRecognised       :   claims[`${justisPrefix}/claims/isiprecognized`],
           FriendlyName         :   claims[`http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name`],
           AuthenticatedByIp    :   claims[`${justisPrefix}/claims/isipauthenticated`],
           Email                :   claims[`http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress`],
           AuthenticationType   :   claims[`${justisPrefix}/claims/authprovider`],
           Idp                  :   claims.idp,
           AuthMessage          :   claims.AuthMessage,
           IsSuperUser          :   claims[`${justisPrefix}/claims/hasauthtoken/super_user_level`] === "2",
           IsProductionUser     :   claims[`${justisPrefix}/claims/hasauthtoken/processing_enabled`] === "Y",
           Sku                  :   claims[`${justisPrefix}/claims/sku`],
           AllowAdmin           :   claims[`${justisPrefix}/claims/hasauthtoken/allow_admin`] === "Y",
           RemainingTrialDays   :   claims[`${justisPrefix}/claims/remainingtrialdays`],
           IsTrialist           :   claims[`${justisPrefix}/claims/istrialuser`],
           Indicators           :   ClaimsHelper.ParseMany(claims[`${justisPrefix}/claims/hasdatasource`]),
           CustomHeader         :   claims[`${justisPrefix}/claims/hasauthtoken/header_image`] || "",
           CustomFooter         :   claims[`${justisPrefix}/claims/hasauthtoken/footer_image`] || "",
           GoldVisionContactId  :   claims[`${justisPrefix}/claims/goldvisioncontactid`],
           GoldVisionAccountId  :   claims[`${justisPrefix}/claims/goldvisionaccountid`],
           FeatureFlags         :   ClaimsHelper.ParseMany(claims[`${justisPrefix}/claims/featureflags`])
        };
    }

    public static ParseMany(value: string | string[]): string[] {
        if (!value) {
            return [];
        }
        if (Array.isArray(value)) {
            return value;
        }
        return [value];
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/authentication/claims-helper.ts